import { render, staticRenderFns } from "./BaseDataTable.vue?vue&type=template&id=0587f4ae&scoped=true&"
import script from "./BaseDataTable.vue?vue&type=script&lang=js&"
export * from "./BaseDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0587f4ae",
  null
  
)

export default component.exports